import React, { useEffect } from 'react'

import {
  setIsBackPromptModalOpen,
  setIsMobileMenuOpen,
  setIsSaveProjectToMailModalOpen,
  setIsSummaryPanelVisible,
} from '../../store/ui/uiSlice'
import ProceedButton from './ProceedButton/ProceedButton'
import Heading from '../Heading/Heading'
import Modal from '../Modal/Modal'
import SummaryPreview from '../SummaryPreview/SummaryPreview'
import Menu from './Menu'
import * as commonStyles from '../styles'
import * as styles from './styles'
import LoftUnavailableModal from '../Modals/LoftUnavailableModal'
import ConfigurationOutdatedModal from '../Modals/ConfigurationOutdatedModal'
import FailedToLoadProjectModal from '../Modals/FailedToLoadProjectModal'
import { useAppDispatch, useAppSelector } from '../../hooks'

const Styled = {
  ...commonStyles,
  ...styles,
}

interface Props {
  onRequestSaveProject: (args: { type: string }) => {
    internalSaveUuidv4: string
  }
}

const AppHeader: React.FC<Props> = ({ onRequestSaveProject }) => {
  const dispatch = useAppDispatch()

  const { content, assetBaseUrl } = useAppSelector((state) => state.init)

  const { isBackPromptModalOpen, isMobileMenuOpen, isSummaryPanelVisible } = useAppSelector((state) => state.ui)

  useAppSelector((state) => state.requests.requestStatus)

  useEffect(() => {
    const handleResize = (): void => {
      if (isMobileMenuOpen) dispatch(setIsMobileMenuOpen(false))
    }

    window.addEventListener('resize', handleResize)

    // Cleanup
    return () => {
      window.removeEventListener('message', handleResize)
    }
  }, [])

  return (
    <>
      <Styled.AppHeader isMobileMenuOpen={isMobileMenuOpen} isButtonBackDisabled={history.length === 1}>
        <div className="header-area">
          {
            <Styled.Logo
              src={`${assetBaseUrl}${content.other.companyLogoImgSrc}`}
              alt={content.other.companyLogoImgAlt}
              onClick={() => {
                if (history.length === 1) {
                  //
                } else {
                  dispatch(setIsBackPromptModalOpen(true))
                }
              }}
              $isSummaryPanelVisible={isSummaryPanelVisible}
            />
          }

          {isSummaryPanelVisible && (
            <Styled.BackLink
              onClick={() => {
                dispatch(setIsSummaryPanelVisible(false))
              }}
            >
              {content.buttons.back}
            </Styled.BackLink>
          )}

          {!isSummaryPanelVisible && <Menu />}

          <SummaryPreview />

          <ProceedButton onRequestSaveProject={onRequestSaveProject} buttonText={content.buttons.addToCart} />
        </div>
      </Styled.AppHeader>

      <Modal
        isOpen={isBackPromptModalOpen}
        onRequestClose={() => {
          dispatch(setIsBackPromptModalOpen(false))
        }}
        contentLabel={content.modals.backPrompt.title} // only for screenreaders
      >
        <Styled.ModalBackPrompt>
          <Heading level={2}>{content.modals.backPrompt.title}</Heading>
          <p>{content.modals.backPrompt.description}</p>
          <p>{content.modals.backPrompt.description_2}</p>
          <Styled.Button
            className="button-secondary"
            onClick={() => {
              dispatch(setIsBackPromptModalOpen(false))
              history.go(isSummaryPanelVisible ? -2 : -1)
            }}
          >
            <i className="fas fa-sign-out" aria-hidden="true" />
            {content.buttons.leave}
          </Styled.Button>
          <Styled.Button
            className="button-primary"
            onClick={() => {
              dispatch(setIsBackPromptModalOpen(false))
              dispatch(setIsSaveProjectToMailModalOpen(true))
            }}
          >
            {content.buttons.saveProject}
          </Styled.Button>
        </Styled.ModalBackPrompt>
      </Modal>

      <LoftUnavailableModal />
      <ConfigurationOutdatedModal />
      <FailedToLoadProjectModal />
    </>
  )
}

export default AppHeader
